var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.648 13.429a.8.8 0 00.608.252.954.954 0 00.608-.252l3.388-3.366a.796.796 0 000-1.178.858.858 0 00-1.216 0L5.04 10.88c.035-4.238 3.081-8.11 7.586-9.088 5.212-1.178 10.336 2.02 11.552 7.068 1.216 5.049-2.084 10.097-7.296 11.19-4.343.927-8.599-1.009-10.596-4.543-.044-.042-.065-.105-.087-.168-.022-.063-.043-.126-.087-.168-.26-.169-.521-.337-.869-.253-.347.084-.694.505-.608.926l.261.505c2.345 4.123 7.296 6.479 12.334 5.385 6.08-1.346 9.815-7.32 8.512-13.21-1.303-5.89-7.383-9.593-13.463-8.247-5.264 1.125-8.803 5.591-8.834 10.6L1.477 8.969a.858.858 0 00-1.216 0 .796.796 0 000 1.178l3.387 3.282z",
    fill: "currentColor"
  })));
}
export default SvgReset;